import styled, { css } from 'styled-components';
import { Color } from 'src/utils/theme';
import BaseIcon from 'src/components/Icon';
import { motion } from 'framer-motion';

export const Wrapper = styled.div<{ $backgroundColor: Color; $active: boolean }>(
  ({ theme, $backgroundColor, $active }) => css`
    background-color: transparent;
    border-radius: ${theme.bo.mediumSmall};
    cursor: pointer;
    display: flex;
    gap: ${theme.sz.s1};
    padding: ${theme.sz.s4} ${theme.sz.s2};
    flex-direction: column;
    -webkit-tap-highlight-color: transparent;

    &[aria-expanded='true'],
    &:focus-visible {
      background-color: ${theme.co[$backgroundColor]};
    }

    &[aria-expanded='false'] {
      padding-bottom: 0;
      padding-top: 0;
    }

    @media (min-width: ${theme.sz.md}) {
      padding: ${theme.sz.s4};
    }

    @media (min-width: ${theme.sz.maxMobileBreakpoint}) {
      padding: ${theme.sz.s4} ${theme.sz.s6};
    }

    @media (min-width: ${theme.sz.xxl}) {
      background-color: ${$active ? theme.co[$backgroundColor] : 'transparent'}!important;

      &:hover {
        background-color: ${theme.co[$backgroundColor]};
      }
    }

    @media (min-width: ${theme.sz.xxxxl}) {
      padding: ${theme.sz.s6};
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xxs}
    align-items: center;
    color: ${theme.co.secondary20};
    display: grid;
    grid-gap: ${theme.sz.s1};
    grid-template-columns: ${theme.sz.s6} 1fr auto;
    grid-template-rows: 1fr;
    min-height: ${theme.sz.s6};

    @media (min-width: ${theme.sz.sm}) {
      ${theme.typography.heading.mobile.xs}
    }

    @media (min-width: ${theme.sz.xxl}) {
      ${theme.typography.heading.desktop.xxs}
      align-items: baseline;
    }
  `,
);

export const IconContainer = styled.div(
  () => css`
    height: 100%;
  `,
);

export const Icon = styled(BaseIcon)<{ $color: Color }>(
  ({ theme, $color }) => css`
    ${theme.typography.heading.mobile.s}
    color: ${theme.co[$color]};
  `,
);

export const Row = styled(motion.div)(
  ({ theme }) => css`
    ${theme.typography.paragraph.m}
    color: ${theme.co.secondary50};
    display: grid;
    grid-gap: ${theme.sz.s1};
    grid-template-columns: ${theme.sz.s6} minmax(2ch, auto) 1fr;

    @media (min-width: ${theme.sz.minMobileBreakpoint}) {
      ${theme.typography.paragraph.base}
    }
  `,
);

export const Column = styled.div<{ $hidden?: boolean }>(
  ({ $hidden }) => css`
    &:last-child {
      white-space: nowrap;
    }

    ${$hidden &&
    css`
      visibility: hidden;
    `}
  `,
);
